import { stringify } from "qs";

/* FIP 트래픽 경로 정리 스프레드 시트 문서: https://docs.google.com/spreadsheets/d/1pdnxZlXZXjd5GJU7G27piwSNZXrHyALcofRMYY_i85g/edit?usp=sharing */

export interface UTMParamType {
  utm_id?: string; // 캠페인 ID. 특정 캠페인 또는 프로모션을 식별하는 데 사용됩니다. GA 4 데이터 가져오기의 필수 키입니다. 캠페인 비용 데이터를 업로드할 때 사용하는 것과 동일한 ID를 사용합니다.
  utm_source?: string; // 리퍼러(예: Google, 뉴스레터4, 빌보드)
  utm_medium?: string; // 마케팅 매체(예: CPC, 배너, 이메일)
  utm_campaign?: string; // 제품, 슬로건, 프로모션 코드(예: spring_sale)
  utm_source_platform?: string; // 특정 애널리틱스 속성(예: 예산과 타겟팅 기준을 설정하는 구매 플랫폼 또는 자연 트래픽 데이터를 관리하는 플랫폼)으로 트래픽을 유도하는 역할을 하는 플랫폼. 예: Search Ads 360 또는 Display & Video 360
  utm_term?: string; // 유료 키워드
  utm_content?: string; // 광고 소재를 구분하는 데 사용합니다. 예를 들어 하나의 이메일 메시지에 두 가지 클릭 유도 문구 링크가 있는 경우 utm_content를 사용하여 각각 다른 값을 설정하면 어떤 버전이 더 효과적인지 확인할 수 있습니다.
}

export function makeUTMQuery(params: UTMParamType) {
  const utmQueryString = stringify(params);

  return utmQueryString;
}

export function getUrlWithUTMParams(url: string, utmParams: UTMParamType) {
  const [originalLocation, originalQuery] = url.split("?");

  // 현재 URL의 쿼리 파라미터 복사
  const updatedParams = new URLSearchParams(originalQuery);

  // 새 UTM 파라미터를 기존 쿼리에 추가 또는 업데이트
  Object.entries(utmParams).forEach(([key, value]) => {
    updatedParams.set(key, value);
  });

  // 새로운 URL 생성 (기존의 path 유지)
  const newPath = `${originalLocation}?${updatedParams.toString()}`;

  return newPath;
}
